import * as React from 'react';

import {useQuery} from '@apollo/react-hooks';

import {translateConnectionObjectToArray} from 'nutshell-core';

import {CTABanner} from 'shells/cta-banner/cta-banner';
import {EmailLatestOutreachList} from 'shells/email-latest-outreach-list/email-latest-outreach-list';
import {InfoIcon} from 'shells/icon/svg/info-icon';
import {UppercaseLabel} from 'shells/typography/uppercase-label';

import type {
    GetEditions as GetEditionsQuery,
    GetEditionsVariables as GetEditionsQueryVariables,
} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';

import {BroadcastMutations} from '../graphql-wrappers/broadcast/broadcast-mutations';
import GET_EDITIONS from '../graphql-wrappers/graphql/queries/get-editions.graphql';

type Props = {
    onCreateNewBroadcast: () => void;
};

export function LatestOutreach(props: Props) {
    const {data, loading, refetch} = useQuery<GetEditionsQuery, GetEditionsQueryVariables>(
        GET_EDITIONS,
        {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network',
            variables: {
                first: 3,
                statuses: ['SENT', 'SENDING', 'SCHEDULED', 'HALTED'],
                campaignTypes: ['BROADCAST', 'NEWSLETTER'],
            },
        }
    );

    const editions = data ? data.editions : null;

    return (
        <BroadcastMutations>
            {({onDelete}) => (
                <div>
                    <div className='mb-8'>
                        <UppercaseLabel>Latest Outreach</UppercaseLabel>
                    </div>
                    {(editions && editions.totalCount > 0) || loading ? (
                        <EmailLatestOutreachList
                            isLoading={loading}
                            editions={editions ? translateConnectionObjectToArray(editions) : []}
                            onViewUrl={(url) => {
                                appHistory.push(url);
                            }}
                            onArchiveBroadcast={(id) => {
                                onDelete(id).then(() => {
                                    refetch();
                                });
                            }}
                        />
                    ) : (
                        <CTABanner
                            icon={InfoIcon}
                            title='What makes a good outreach email?'
                            text='We’ve created 6 example templates to get you started.'
                            buttonText='View templates'
                            onPrimaryAction={props.onCreateNewBroadcast}
                        />
                    )}
                </div>
            )}
        </BroadcastMutations>
    );
}
